import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

var _templateObject;

import { InputNumber as AntInputNumber } from 'antd';
import styled from 'styled-components';
var InputNumber = styled(AntInputNumber)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  &.ant-input-number {\n    width: 100%;\n    color:", ";\n    &.ant-input-number-focused {\n      box-shadow: none;\n    }\n  }\n"])), function (props) {
  return props.theme.colors[props.valueColor];
});
export default InputNumber;